import { FunctionComponent, h } from 'preact';
import { Text } from 'preact-i18n';
import { LocationType, NBSP } from '../../../../common';
import { isNotBlank } from '../../../../utils';
import { FinText } from '../../../../i18n';

export interface AriaLiveResultsProps {
  locationType: LocationType;
  results: number;
  query: string;
  isLoading: boolean;
}

export const AriaLiveResults: FunctionComponent<AriaLiveResultsProps> = ({
  locationType,
  results,
  query,
  isLoading,
}: AriaLiveResultsProps) => {
  return (
    <div class="is-vishidden" role="status" aria-live="assertive" tabIndex={-1}>
      {isNotBlank(query) && !isLoading && (
        <div>
          <Text
            id={`locationModal.${locationType}.results`}
            plural={results}
            fields={{ count: String(results), query }}
          />
          .{NBSP}
          {results > 0 && <FinText id="locationModal.selectionKeys" />}
        </div>
      )}
    </div>
  );
};
